const CTA_CONFIG_EXPERIENCE_NOT_ADDED = {
  text:     'Create',
  added:    false,
  disabled: false,
  isWide:   false,
  tooltip:  'You can create a new experience with this app',
};

const CTA_CONFIG_EXPERIENCE_ADDED = {
  text:     CTA_CONFIG_EXPERIENCE_NOT_ADDED.text,
  added:    true,
  disabled: false,
  isWide:   false,
  tooltip:  CTA_CONFIG_EXPERIENCE_NOT_ADDED.tooltip,
};

const CTA_CONFIG_EXPANSION_NOT_REQUESTED = {
  text:     'Request info',
  added:    null,
  disabled: false,
  isWide:   true,
  tooltip:  'Click to request more info about this package',
};

const CTA_CONFIG_EXPANSION_REQUESTED = {
  text:     'Info requested',
  added:    null,
  disabled: true,
  isWide:   true,
  tooltip:  'Thank you! We\'ve sent this request to your Customer Success Manager who will be in touch shortly',
};

const AppStoreConstants = {
  CTA_CONFIG_EXPANSION_NOT_REQUESTED,
  CTA_CONFIG_EXPANSION_REQUESTED,
  CTA_CONFIG_EXPERIENCE_ADDED,
  CTA_CONFIG_EXPERIENCE_NOT_ADDED,
};

export default AppStoreConstants;
